import ActivityData from '../../models/activity_data'
import BaseApi from '../base/base'

export default class TrackingApi extends BaseApi {
  constructor() {
    super()
    this.path = '/activities'
  }

  async get(page: number, dateRage = {}) {
    this.path = '/activities'
    const response = await this.getRequest({
      page, dateRage
    })
    return new ActivityData(response.data)
  }
}
